/**
 * CIS (rugby) org allowlist — OPUS-1234.
 *
 * The single source of truth for which orgs run the CIS/rugby view. Everything
 * else derives from this: the route namespace an org lands on (`/cis/` vs
 * `/competition/`), and the route guards that stop an org opening the wrong
 * view.
 *
 * This is deliberately client-side config, not a session field. The session
 * service mints the same `?session=`/`?h=` payload for every org — it carries
 * no sport — so the app decides the namespace itself. When user-management
 * starts issuing a real `sport` (or `app`) claim, replace the body of
 * `isCisOrg` with that lookup and leave every caller untouched.
 *
 * Org IDs are the same values that appear in the URL, e.g.
 *   /competition/67e67728af1b0c162b2f47e1/...
 */

/** Orgs that run the CIS/rugby view. Add an org ID here to switch it over. */
export const CIS_ORG_IDS = new Set([
  // TODO(OPUS-1234): replace with the real CIS org ID(s) before this ships.
  // Left empty on purpose — an empty set means every org keeps today's
  // football behaviour, so merging this is a no-op until an ID is added.
  //
  // Verified locally (PR 4595 remediation): temporarily adding a real org ID
  // here to exercise the /cis/:orgId route + NamespaceGuard + ProtectedRoute
  // end to end confirmed the routing works. Reverted back to empty afterwards
  // — routePaths.test.js's own FOOTBALL_ORG fixture happens to be the same ID
  // used as this file's own doc-comment example above, so leaving a real
  // entry here breaks that unrelated test's "this org is NOT cis" assumption.
]);

/** True if this org runs the CIS/rugby view. */
export const isCisOrg = (orgId) => !!orgId && CIS_ORG_IDS.has(String(orgId));
